<template>
  <div>
    <div class="flex mb-4">
      <div>
        <v-text-field
          label="Street"
          v-model='user.info.address.street'
          required>{{user.info.address.street}}</v-text-field>
      </div>
    </div>
    <v-layout
      row
      wrap>
      <v-flex
        xs12
        sm4>
        <v-text-field
          label="City"
          v-model='user.info.address.city'
          required>{{user.info.address.city}}</v-text-field>
      </v-flex>
      <v-flex
        xs12
        sm4>
        <v-text-field
          label="State"
          v-model='user.info.address.state'
          required>{{user.info.address.state}}</v-text-field>
      </v-flex>
      <v-flex
        xs12
        sm4>
        <v-text-field
          label="Zip Code"
          v-model='user.info.address.zip'
          required>{{user.info.address.zip}}</v-text-field>
      </v-flex>
    </v-layout>
  </div>
</template>


<script>
  import { mapFields } from 'vuex-map-fields';

  export default {
    data () {
      return {
        dialog: false,
      }
    },
    mounted() {
      if (typeof this.user.info.address === 'string') {
        this.user.info.address = {
          street: '',
          city: '',
          state: '',
          zip: ''
        }
      }
    },
    methods: {

    },
    computed: {
      ...mapFields([
        'user',
        'snackBarshow',
        'snackBarType',
        'snackBarmessage',
      ]),
    }
  }
</script>
